import { deviceInfo } from "./device-info.model";
import { IntDropDownItem, GenericResponse, SimpleResponse } from "./genericResponse.model";
import { PasswordPolicy } from "./passwordPolicy.model";
import { RoleFeaturePermissions } from "./roleContainer.model";

export interface CLPUser {
    cLPUserID: number;
    cLPSSID: number;
    userName: string;
    firstName: string;
    lastName: string;
    email: string;
    cLPCompanyID: number;
    userRole: number;
    teamCode: number;
    encryptedPassword: string;
    //pwd: string;
    resetPassword: ResetPassword;
    currentDeviceId: string;
    isPasswordAdmin: boolean;
    companyName: string;
    slurpyUserId: number;
    slurpyCompanyId: number;
    isShowCP: boolean;
    status: number;
    standardName: string;
    //contact-module
    fullName: string
    officeCode: number


    //cLPSSID: number;
    //employeeID: number;
    permissions: number;
    changePW: number;
    timeZone: number;
    timeZoneWinId: number;
    dateFormat: string;
    dateFormatId: number;
    password: string;
    TxtMsgTollFree: string;
    //question: string;
    //answer: string;
    //middleInitial: string;
    //title: string;
    //add1: string;
    //add2: string;
    //add3: string;
    //city: string;
    //state: string;
    //zip: string;
    //country: string;
    enableSkype: number;
    phone: string;
    mobile: string;
    altPhone: string;
    fax: string;
    enableFax2Mail: boolean;
    //fax2EmailFrom: string;
    //otherEmail: string;
    //useBothEmail: boolean;
    //emailFormat: number;
    defaultSignature: string;
    hTMLSignature: string;
    //fromDisplayName: string;
    //uAlias: string;
    emailTemplateID: number;
    //helpMode: boolean;
    isNewUser: boolean;
    //dShareContact: boolean;
    //dOutlookSync: boolean;
    isAllowDownload: boolean;
    //facebookURL: string;
    //twitterURL: string;
    //linkedInURL: string;
    enableCLPSMTP: boolean;
    //enableiPhone: boolean;
    //dtCreated: Date;
    txtMsgLongCode: string;
    //dtPassword: Date;
    //failedAttempts: number;
    //pwdChangeInDay: number;
    //isLocked: number;
    //dtlocked: Date;
    //passwordHash: string;
    //    countryCode: string;
    country: string;
    theme: number;
    deviceInfo: deviceInfo,
    youTubeURL: string;
    instagramURL: string;
    authorize: boolean;
    isExpired: boolean;
    isLongcodeOnLogin: boolean;
}

export interface ResetPassword {
    currentPassword: string;
    //currentPwd: string;
    newPassword: string;
    //newPwd: string;
    isForget: number;
}

export interface UserResponse extends SimpleResponse {
    user: CLPUser;
    userId: number;
    encryptedToken: string;
    exists: boolean;
    msg: string;
    isvalid: number;
    passwordPolicy: PasswordPolicy;
    roleFeaturePermissions: RoleFeaturePermissions;
    theme: number;
}

export interface UserListResponse extends SimpleResponse {
    clpUsers: CLPUser[];
}

//contact-module
export interface SimpleUserListResponse extends GenericResponse {
    users: CLPUser[];
    clpUserId: number;
}


export interface UserSetupResponse extends GenericResponse {
    users: CLPUser[];
    newCLPUsers: CLPUser[];
    filterTeam: any;
    filterOffice: any;
    timeZoneWin: any;
    dateFormat: any;
    filterRoles: any;
}
export interface TeamCode {
    temCode: number;
    cLPCompanyID: number;
    display: string;
    sOrder: number;
}

export interface CLPUserProfile extends SimpleResponse {
    encryptedPassword: string;
    cLPUserID: number;
    cLPCompanyID: number;
    cLPSSID: number;
    teamCode: number;
    userName: string;
    password: string;
    question: number;
    answer: string;
    officeCode: number;
    lastName: string;
    firstName: string;
    fullName: string;
    middleInitial: string;
    employeeID: string;
    permissions: number;
    changePW: number;
    timeZone: number;
    timeZoneWinId: number;
    userRole: number;
    title: string;
    add1: string;
    add2: string;
    add3: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    enableSkype: boolean;
    phone: string;
    mobile: string;
    altPhone: string;
    fax: string;
    enableFax2Mail: boolean;
    fax2EmailFrom: string;
    email: string;
    otherEmail: string;
    useBothEmail: boolean;
    emailFormat: number;
    defaultSignature: string;
    hTMLSignature: string;
    fromDisplayName: string;
    uAlias: string;
    emailTemplateID: number;
    helpMode: boolean;
    isNewUser: boolean;
    dShareContact: boolean;
    dOutlookSync: boolean;
    isAllowDownload: boolean;
    facebookURL: string;
    twitterURL: string;
    linkedInURL: string;
    enableCLPSMTP: boolean;
    enableiPhone: boolean;
    dtCreated: Date;
    txtMsgLongCode: string;
    dtPassword: Date;
    failedAttempts: number;
    pwdChangeInDay: number;
    isLocked: number;
    dtlocked: Date;
    isPasswordAdmin: boolean;
    passwordHash: string;
    slurpyUserId: number;
    companyName: string;
    status: number;
    isShowCP: boolean;
    countryCode: string;
    dateFormatId: number;
    theme: number;
    TxtMsgTollFree: string;
    youTubeURL: string;
    instagramURL: string
}

export interface OfficeCodes {
    officeCode: number;
    cLPCompanyID: number;
    display: string;
    sOrder: number;
}

export interface OfficeCodeResponse extends GenericResponse {
    selectedValue: string;
    officeCodes: OfficeCodes[];
}


export interface OfficeCodeResponseIEnumerable extends GenericResponse {
    officeCodes: OfficeCodes[];

}
export interface TeamCodes {
    teamCode: number;
    cLPCompanyID: number;
    display: string;
    sOrder: number;
    companyName: string;
}

export interface TeamCodeResponse extends GenericResponse {
    selectedValue: string;
    teamCodes: TeamCodes[];
}
export interface TeamCodeResponseIEnumerable extends GenericResponse {
    teamCodes: TeamCodes[];
}

export interface TeamOfficeSetting {
    showTeamDD: boolean;
    showOfficeDD: boolean;
}

export interface VoiceRecordingType {
    voiceRecordingTypeID: number;
    cLPCompanyID: number;
    display: string;
    sOrder: number;
    script: string;
}

export interface VoiceRecordingFilterResponse extends GenericResponse {
    voiceRecordings: VoiceRecordingType[];
}

export interface SFAResponse extends SimpleResponse {
    companyName: string;
    userList: IntDropDownItem[];
}

export interface UserResourcesUsed {
    output: string
}

export interface IphoneUsers {
    fullname: string;
    clpUserId: number;
    enableiPhone: boolean;
}

export interface IPhoneUserListsResponse extends SimpleResponse {
    iPhoneEnableUserList: IphoneUsers[];
    iPhoneDisableUserList: IphoneUsers[];
}


export interface FeatureAccess {
    roleId: number;
    featureId: number;
    view: boolean;
    create: boolean;
    edit: boolean;
    delete: boolean;
    clpCompanyId: number;
}

/* BI Report Model Start*/
export interface SimpleUserListResponse extends GenericResponse {
    users: CLPUser[];
    clpUserId: number;
}

/* BI Report Model End*/

/*mobile login*/

export interface IPLog {
    ip: string;
    page: string;
    countryCode: string;
    spam: boolean;
    tor: boolean;
    city: string;
    detail: string;
}
/*mobile login*/

export interface UserDD {
    value: number;
    text: string;
}

export interface ClpUsersDdResponse {
    clpUsers: IntDropDownItem[];
}

export interface LoadUserResponse {
    userDD: IntDropDownItem[];
    clpUsersList: string;
}

export interface CLPUserPrefFilterResponse extends SimpleResponse {
    teamCodes: TeamCodes[];
    officeCodes: OfficeCodes[];
    isShowTeamDD: boolean;
    isShowOfficeDD: boolean;
}

export interface LoadUserObj {
    clpCompanyId: number;
    clpUserId: number;
    selectedUserId: number;
    officeCode: number;
    teamCode: number;
    isOfficeMy: boolean;
    isTeamMy: boolean;
    isOfficedChecked: boolean;
    isTeamChecked: boolean;
    blnSetUser: boolean;
}

export interface DDFields {
    classCode: number;
    display: string;
}

export interface DDFieldsResponse extends SimpleResponse {
    lstDDFields: DDFields[];
}


export interface DDFieldResponse extends SimpleResponse {
    ddFields: DDFields[];
}


export interface UserDefaultLoadResponse extends SimpleResponse {
    clpUserDefaults: clpUserDefaults
}

export interface clpUserDefaults {
    cLPCompanyID: number;
    cLPUserID: number;
    sMSStartTimeWeekDay: string;
    sMSEndTimeWeekDay: string;
    sMSStartTimeWeekend: string;
    sMSEndTimeWeekend: string;
    voiceStartTimeWeekDay: string;
    voiceEndTimeWeekDay: string;
    voiceStartTimeWeekend: string;
    voiceEndTimeWeekend: string;
    contactSectionOrder: string
    verticalDisplaysetting: string;
}

export interface ContactSectionOrderSaveRequest {
    cLPUserID: number;
    contactSectionOrder: string
}

export interface ProcessActiveHoursSaveRequest {
    cLPCompanyID: number;
    cLPUserID: number;
    strSMSStartTimeWeekDay: string;
    strSMSEndTimeWeekDay: string;
    strSMSStartTimeWeekend: string;
    strSMSEndTimeWeekend: string;
    strVoiceStartTimeWeekDay: string;
    strVoiceEndTimeWeekDay: string;
    strVoiceStartTimeWeekend: string;
    strVoiceEndTimeWeekend: string;
    contactSectionOrder: string
}


//export interface ProcessActiveHoursSaveRequest {
//  cLPCompanyID: number;
//  cLPUserID: number;
//  sMSStartTimeWeekDay: string;
//  sMSEndTimeWeekDay: string;
//  sMSStartTimeWeekend: string;
//  sMSEndTimeWeekend: string;
//  voiceStartTimeWeekDay: string;
//  voiceEndTimeWeekDay: string;
//  voiceStartTimeWeekend: string;
//  voiceEndTimeWeekend: string;
//  contactSectionOrder : string
//}


export interface CheckListLoadResponse extends SimpleResponse {
    sgCheckList: GSCheckList[];
}

export interface GSCheckList {
    gSCheckListID: number;
    userRole: number;
    title: string;
    description: string;
    helpTopicLink: string;
    videoLink: string;
    sOrder: number;
    isDone: boolean;
}

export interface AllowedUserListResponse extends SimpleResponse {
    allowedUserList: AllowedUserList[];
}

export interface AllowedUserList {
    cLPUserId: number;
    fullname: string;
    fullname_username: string;
}

export interface UserSetupExcel {
    userCode: string;
    lastName: string;
    firstName: string;
    office: string;
    team: string;
    userName: string;
    timeZone: string;
    role: string;
}
